var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.075,
    height: 9.182,
    viewBox: "0 0 13.075 9.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    transform: "translate(0.537 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M7,4.5A6.451,6.451,0,0,0,1,8.591a6.445,6.445,0,0,0,12,0A6.451,6.451,0,0,0,7,4.5Z",
    transform: "translate(-1 -4.5)",
    fill: "none",
    stroke: "#2e3546",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M-3425.74-2867.049a6.424,6.424,0,0,0,4.455,2.155,5.4,5.4,0,0,0,4.144-2.155",
    transform: "translate(3427.544 2871.412)",
    fill: "none",
    stroke: "#2e3546",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.0c1bb7d59c0dfa514dfff6ce70c5a748.svg";
export { ForwardRef as ReactComponent };